import path from "./path";
import sanitize from "./sanitize";
export { sanitize, path };
export default {
  sanitize,
  path,
};
